import React from "react";
import useFetch from "../../hooks/useFetch";
import { Link, useNavigate } from "react-router-dom";
import { getToken, removeToken } from "../../helpers";

const ListOrders = () => {
  const navigate = useNavigate();
  const { data, loading, error } = useFetch(`/orders?populate=*`, getToken());
  if (error) {
    removeToken();
    navigate("/SignIn", { replace: true });
  }
  function dateDiff(date1, date2) {
    const msInSecond = 1000;
    const msInMinute = msInSecond * 60;
    const msInHour = msInMinute * 60;
    const msInDay = msInHour * 24;

    const diffInMs = new Date(date2) - new Date(date1);
    let res = {
      days: Math.floor(diffInMs / msInDay),
      hours: Math.floor((diffInMs % msInDay) / msInHour),
      minutes: Math.floor((diffInMs % msInHour) / msInMinute),
      seconds: Math.floor((diffInMs % msInMinute) / msInSecond)
    };
    let diff = "";
    if (res.days > 1) {
      diff = res.days + " days";
    } else {
      diff = res.hours + " hours " + res.minutes + " minutes";
    }
    return diff;
  }

  return (
    <div className="row">
      {loading
        ? "loading"
        : data?.map((item, index) => (
          <div className="p-3 col-md-4" key={index}>
            <div className="card rounded-0">
              <div className="card-body">
                {JSON.parse(item.products).map((prod) => <>
                  <Link to={`/product/${prod.id}`} key={prod.id} className="position-relative">
                    <span className="position-absolute start-100 translate-middle badge rounded-pill bg-dark">
                      {prod.quantity}
                    </span>
                    <img className="ms-3" style={{height: "50px"}} src={process.env.REACT_APP_UPLOAD_URL + prod.img} alt="" />
                  </Link>
                </>)}
                <p className="mt-3 mb-0 fs-6">
                  Total Amount : ₹ {item.total_price}<br/>
                  Status : {item.order_status}<br/>
                  Mode : {item.order_payment_type}<br/>
                </p>
                <p className="mb-0 mt-0 text-end"><span className="blockquote-footer">{dateDiff(item.created_at, new Date())}</span></p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ListOrders;
